import { Component, OnInit } from '@angular/core';
import { OrganisationsService } from 'app/_services/organisations.service';
import {MatSnackBar} from '@angular/material';
@Component({
  selector: 'app-organisation-type-master',
  templateUrl: './organisation-type-master.component.html',
  styleUrls: ['./organisation-type-master.component.scss']
})
export class OrganisationTypeMasterComponent implements OnInit {
  orgTypeList: any;
  productLoading:Boolean=false
  totalRecords = 0;
  page = 0;
  size = 10;
  organisationTypeFilter: any = {
    orgtype: "",
    orgtypestatus: "Active"
  };
  constructor(
    private orgservice:OrganisationsService,
    private snackbar:MatSnackBar,
  ) { }

  ngOnInit() {
    this.getorgTypeList(1, this.organisationTypeFilter);
  }

  getorgTypeList(page: number, organisationTypeFilter:any) {
    this.orgservice.getOrganisationTypeList(page - 1, this.size, organisationTypeFilter).subscribe((response) => {
      
      this.productLoading=true

      if(response.status_code == 200){
        this.orgTypeList = response.Data;
        this.totalRecords = response.total_count;
        this.page = page;
        this.productLoading=false
        
      }else{
        this.orgTypeList = [];
        this.totalRecords = 0 ;
        this.productLoading=false

        this.snackbar.open(response.Metadata.Message, '', {
          duration: 2000,
          verticalPosition:"top",
          extraClasses: ['bg-red']
        });


      }
    },(err: any) => console.log("error", err),() =>
        console.log("getCustomersPage() retrieved customers for page:", +page)
    );
  }

  onSubmit() {
    this.getorgTypeList(1, this.organisationTypeFilter);
  }

  clearfilter() {
    this.organisationTypeFilter.orgtype = "";
    this.organisationTypeFilter.orgtypestatus = "";
    this.getorgTypeList(1, this.organisationTypeFilter);
  }

  pageChanged(event) {
    this.getorgTypeList(event, this.organisationTypeFilter);
  }
}



// WEBPACK FOOTER //
// ./src/app/component/organisation-type-master/organisation-type-master.component.ts